import React from 'react';
import ImageNext, { ImageProps } from 'next/image';

import styles from './Image.module.scss';

interface IImage extends ImageProps {
  src: string;
  aspectRatio?: string;
  width?: string;
  height?: string;
}

export const Image: React.VFC<IImage> = ({
  src,
  aspectRatio = '1.5/1',
  width = '100%',
  height = '100%',
  ...rest
}) => {
  // Fix that replaces aspectRatio for older browsers prior to Safari 15
  const ratioValues = aspectRatio.split('/');
  const paddingPercentage = (Number(ratioValues[1]) / Number(ratioValues[0])) * 100;

  return (
    <span
      className={styles['image-container']}
      style={{ paddingBottom: `${paddingPercentage}%`, width, height }}
    >
      {/* NEEDS to spread props if needed to override Next js image props  */}
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <ImageNext className={styles.image} src={src} alt="" layout="fill" {...rest} />
    </span>
  );
};
